export const CREDIT_CARD = 'credit_card'
export const PAYPAL = 'paypal'
export const AFFIRM = 'affirm'
export const STRIPE_PAYMENT = 'stripe_payment'
export const EXPRESS_CHECKOUT = 'express_checkout'
export const APPLE_PAY = 'apple_pay'
export const GOOGLE_PAY = 'google_pay'
export const GIFT_CARD = 'gift_card'
